import { Reveal } from '../components/hareket'
import { Baslik, SayfaUstu, Section } from '../components/ui'
import { useHead } from '../lib/head'

/**
 * Hukuki metinler. TASLAK: yayına girmeden hukuk danışmanı gözden geçirmeli.
 * Metinler platformun gerçek işleyişine göre yazıldı (docs/adr, ADR-14 saklama).
 */
interface Bolum {
  baslik: string
  paragraflar: string[]
}

function HukukSayfasi({
  yol,
  baslik,
  aciklama,
  guncelleme,
  bolumler,
}: {
  yol: string
  baslik: string
  aciklama: string
  guncelleme: string
  bolumler: Bolum[]
}) {
  useHead({ title: baslik, description: aciklama }, yol)
  return (
    <SayfaUstu>
      <Section className="pt-0 sm:pt-0" dar>
        <Reveal>
          <Baslik
            seviye="h1"
            eyebrow={`Son güncelleme ${guncelleme}`}
            baslik={baslik}
            metin={aciklama}
          />
        </Reveal>
        <div className="mt-10 space-y-8">
          {bolumler.map((b) => (
            <section key={b.baslik}>
              <h2 className="heading text-xl text-ink">{b.baslik}</h2>
              <div className="prose-ad mt-3 text-[15px] leading-relaxed text-ink-2">
                {b.paragraflar.map((p, i) => (
                  <p key={i}>{p}</p>
                ))}
              </div>
            </section>
          ))}
        </div>
      </Section>
    </SayfaUstu>
  )
}

export function Kvkk() {
  return (
    <HukukSayfasi
      yol="/kvkk"
      baslik="Kişisel verilerin korunması aydınlatma metni"
      aciklama="6698 sayılı Kanun kapsamında, bu web sitesi ve Akıllı Dernek platformu üzerinden işlenen kişisel verilere ilişkin aydınlatma."
      guncelleme="Eylül 2026"
      bolumler={[
        {
          baslik: 'Veri sorumlusu ve veri işleyen ayrımı',
          paragraflar: [
            'Bu web sitesi (akillidernek.com) üzerinden iletişim formuyla paylaştığınız veriler bakımından veri sorumlusu Akıllı Dernek’tir.',
            'Platformu kullanan derneklerin üyelerine ait veriler bakımından veri sorumlusu ilgili dernektir; Akıllı Dernek bu verileri dernek adına ve talimatıyla işleyen veri işleyendir. Dernek ile Akıllı Dernek arasında veri işleme sözleşmesi imzalanır.',
          ],
        },
        {
          baslik: 'İşlenen veriler ve amaç',
          paragraflar: [
            'İletişim formunda ad, e-posta, dernek adı, isteğe bağlı telefon ve mesajınız işlenir. Amaç yalnızca talebinize dönmektir; pazarlama listesine eklenmez.',
            'Sitede analitik çerez kullanılmaz ve tarayıcınızda tercih saklanmaz.',
          ],
        },
        {
          baslik: 'Saklama ve imha',
          paragraflar: [
            'İletişim talepleri, talep sonuçlandıktan sonra en geç bir yıl içinde silinir. Platformdaki dernek verileri sözleşme süresince, sözleşme bitiminden sonra doksan gün saklanır ve ardından imha edilir; yasal saklama yükümlülüğü olan kayıtlar süre sonuna kadar erişime kapalı tutulur.',
          ],
        },
        {
          baslik: 'Aktarım',
          paragraflar: [
            'Veriler Türkiye’deki sunucularda tutulur. E-posta gönderimi için kullanılan altyapı sağlayıcısına yalnızca gönderim için gereken alıcı bilgisi aktarılır. Ödeme kart bilgileri Akıllı Dernek tarafından hiçbir zaman saklanmaz; ödeme sağlayıcısında işlenir.',
          ],
        },
        {
          baslik: 'Haklarınız',
          paragraflar: [
            'Kanunun 11. maddesi kapsamındaki haklarınızı (bilgi talep etme, düzeltme, silme, itiraz) merhaba@akillidernek.com adresine yazarak kullanabilirsiniz. Başvurular en geç otuz gün içinde yanıtlanır.',
          ],
        },
      ]}
    />
  )
}

export function Gizlilik() {
  return (
    <HukukSayfasi
      yol="/gizlilik"
      baslik="Gizlilik politikası"
      aciklama="Web sitesinde ve platformda hangi bilginin ne için toplandığı, kimin görebildiği."
      guncelleme="Eylül 2026"
      bolumler={[
        {
          baslik: 'Web sitesi',
          paragraflar: [
            'Bu site üçüncü taraf izleme çerezi kullanmaz. Sunucu erişim kayıtları güvenlik amacıyla en fazla otuz gün tutulur.',
          ],
        },
        {
          baslik: 'Platform',
          paragraflar: [
            'Her derneğin verisi veritabanı seviyesinde ayrılır. Akıllı Dernek personeli bir derneğin verisine yalnızca derneğin açtığı destek talebi kapsamında, salt okunur ve denetim kaydına yazılarak erişir.',
            'Ödeme ve SMS sağlayıcı anahtarları şifreli saklanır; düz metin olarak hiçbir ekranda gösterilmez.',
          ],
        },
        {
          baslik: 'Alt işleyenler',
          paragraflar: [
            'Barındırma, e-posta gönderimi ve yedekleme için kullanılan hizmet sağlayıcıların listesi talep üzerine paylaşılır; listede değişiklik olduğunda aboneler önceden bilgilendirilir.',
          ],
        },
      ]}
    />
  )
}

export function Kosullar() {
  return (
    <HukukSayfasi
      yol="/kosullar"
      baslik="Kullanım koşulları"
      aciklama="Akıllı Dernek aboneliğinin temel koşulları. Ayrıntılı sözleşme abonelik başlangıcında imzalanır."
      guncelleme="Eylül 2026"
      bolumler={[
        {
          baslik: 'Hizmet',
          paragraflar: [
            'Akıllı Dernek, dernek, vakıf ve federasyonlara abonelik esasıyla sunulan bir yönetim platformudur. Plan ve paket kapsamı fiyatlandırma sayfasında yazılıdır; plan değişikliği anında uygulanır.',
          ],
        },
        {
          baslik: 'Deneme ve ödeme',
          paragraflar: [
            'Deneme süresi on dört gündür, kart bilgisi istenmez. Deneme sonunda abonelik başlatılmazsa hesap askıya alınır; veri doksan gün saklanır.',
            'Ücretler KDV hariçtir. Yıllık ödemede on iki ay yerine on ay bedeli faturalanır. Ödeme gecikmesinde panel erişimi geçici olarak kapatılır; veri silinmez.',
          ],
        },
        {
          baslik: 'Veri ve sorumluluk',
          paragraflar: [
            'Platformda tutulan üye kayıtları ve mali kayıtlar, mevzuattaki resmî defter ve belgelerin yerine geçmez; derneğin bunları düzenli tutmasına yardım eder. Resmî belge düzenleme ve bildirim yükümlülükleri derneğe aittir.',
            'Dernek, üyelerinden gerekli aydınlatma ve onayları almaktan sorumludur. Akıllı Dernek veri işleyen sıfatıyla yalnızca derneğin talimatıyla işlem yapar.',
          ],
        },
        {
          baslik: 'Fesih',
          paragraflar: [
            'Abonelik dönem sonunda bildirimle sona erdirilebilir. Dernek verisini her an dışa aktarabilir; fesih sonrası doksan günlük saklama süresinin ardından veri imha edilir.',
          ],
        },
      ]}
    />
  )
}
